import React, { useRef } from 'react';
import Resizer from '../Resizer';
import { isTouch } from '../../../../components/utils/browser';
import { useEditorContainerSize } from '../../../../components/Editor/Context';
import { useWidth } from '../../hooks/useWidth';
import viewerStyles from '../../Viewer/Viewer.scss';
const DaGallery = ({ deviations, layout, layoutSpacing, layoutRowAlignment, itemCropping, gridItemWidth, gridItemHeight, torpedoRowHeight, linkOverrides, Renderer, onResizeEnd, extOptions, attrWidth, defaultWidth, editorDomRef, alignment })=>{
    const containerSize = useEditorContainerSize();
    const blockRef = useRef(null);
    const { width, maxWidth } = useWidth(attrWidth, defaultWidth, extOptions.smallMedia, containerSize !== null && containerSize !== void 0 ? containerSize : 0);
    if (!deviations) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: viewerStyles['deviation-gallery'],
        ref: blockRef,
        style: {
            width
        },
        "data-dagallery": "true",
        "data-da-type": "da-gallery",
        "data-width": attrWidth,
        "data-alignment": alignment !== null && alignment !== void 0 ? alignment : extOptions.defaultAlignment,
        "data-layout": layout !== null && layout !== void 0 ? layout : extOptions.defaultLayout,
        "data-layoutspacing": layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : extOptions.defaultLayoutSpacing,
        "data-layoutrowalignment": layoutRowAlignment,
        "data-itemcropping": itemCropping !== null && itemCropping !== void 0 ? itemCropping : 'crop',
        "data-griditemwidth": gridItemWidth !== null && gridItemWidth !== void 0 ? gridItemWidth : extOptions.defaultGridItemWidth,
        "data-griditemheight": gridItemHeight !== null && gridItemHeight !== void 0 ? gridItemHeight : extOptions.defaultGridItemHeight,
        "data-torpedorowheight": torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : extOptions.defaultTorpedoRowHeight
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            maxHeight: '100%',
            pointerEvents: 'none',
            zIndex: -1
        }
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviations: deviations,
        width: width,
        extOptions: extOptions,
        linkOverrides: linkOverrides,
        layoutSpacing: layoutSpacing,
        layoutRowAlignment: layoutRowAlignment,
        itemCropping: itemCropping,
        gridItemWidth: gridItemWidth,
        gridItemHeight: gridItemHeight,
        torpedoRowHeight: torpedoRowHeight,
        layout: layout
    })), !isTouch() && extOptions.canResize && /*#__PURE__*/ React.createElement(Resizer, {
        key: width,
        editorDom: editorDomRef.current,
        imageRef: blockRef,
        minWidth: 10,
        maxWidth: maxWidth,
        minHeight: 10,
        maxHeight: Infinity,
        keepRatio: true,
        onResizeEnd: onResizeEnd
    }));
};
DaGallery.displayName = 'DaGallery';
export default DaGallery;

//# sourceMappingURL=DaGallery.js.map